module.exports = __webpack_public_path__ + "static/media/karoline-gawenda.b95ad003.png";